import {
    Component,
    Inject,
    OnDestroy,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Subject } from 'rxjs';
import { BaseEmissionDesignatorOperationModalData } from './models/base-emission-designator-operation-modal-data';
import { EmissionDesignatorOperationComponent } from '../emission-designator-operation/emission-designator-operation.component';
import { ExistingLicenseEmissionDesignatorOperationComponent } from '../existing-license-emission-designator-operation/existing-license-emission-designator-operation.component';

@Component({
    selector: 'app-emission-designator-operation-base',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export abstract class BaseEmissionDesignatorOperationComponent<T>
    implements OnDestroy
{
    singleFrequencyAction: boolean;

    abstract destroy$: Subject<void>;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: BaseEmissionDesignatorOperationModalData<T>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        protected readonly dialogRef: MatDialogRef<
            | EmissionDesignatorOperationComponent
            | ExistingLicenseEmissionDesignatorOperationComponent
        >,
    ) {
        this.singleFrequencyAction = this.data.controls.length === 1;
    }

    abstract onAddEmissionDesignator(event: MatAutocompleteSelectedEvent): void;

    abstract onDeleteEmissionDesignator(
        event: MatAutocompleteSelectedEvent,
    ): void;

    abstract onRemoveAddedEmissionDesignator(code: string): void;

    abstract onRemoveDeletedEmissionDesignator(code: string): void;

    abstract onSave(): void;

    protected abstract isManualEmissionDesignatorOption(code: string): boolean;

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    close(): void {
        this.dialogRef.close();
    }

    getFrequencyTitle(): string {
        let title;
        if (this.singleFrequencyAction) {
            const frequency = this.data.controls[0];

            const frequencyLow = frequency.controls.frequencyLow.value;
            const frequencyHigh = frequency.controls.frequencyHigh.value;

            if (frequencyLow === null && frequencyHigh === null) {
                return '';
            }

            title = [frequencyLow, frequencyHigh]
                .filter((f) => f !== null)
                .join(' - ');
        } else {
            title = 'Multiple Frequencies';
        }

        return `(${title})`;
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
